import intersection from 'lodash/intersection';
import isArray from 'lodash/isArray';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import mergeWith from 'lodash/mergeWith';
import union from 'lodash/union';
import without from 'lodash/without';
import { EThreadPermission, IThread } from '../api/models/thread/thread.types';
import { IPaginatedStoreResource } from '../helpers/pagination';
import { initialRootState } from '../initialRootState';
import { EMessagesActionType, TMessagesActions } from '../messages/actions';
import {
  EThreadActionType,
  EThreadsActionType,
  TThreadAction,
  TThreadsAction,
} from './actions';

export interface IThreadsState extends IPaginatedStoreResource {
  entries: {
    [id: string]: IThread;
  };
  list: string[];
}

// TODO: Refactor with Immer
export const threadsReducer = (
  currentState: IThreadsState = initialRootState.threads,
  action: TThreadsAction | TThreadAction | TMessagesActions
): IThreadsState => {
  switch (action.type) {
    case EThreadsActionType.GET_SUCCESS:
      return {
        ...currentState,
        entries: mergeWith(
          {},
          currentState.entries,
          action.payload.entities.threads,
          concatArrayUnique
        ),
        list: union(currentState.list, action.payload.result.data), // union remove duplicated
        meta: {
          currentPage: action.payload.result.meta.pagination.current_page,
          total: action.payload.result.meta.pagination.total,
        },
      };
    case EThreadActionType.NEW_MESSAGE:
      return {
        ...currentState,
        entries: mergeWith(
          {},
          currentState.entries,
          {
            [action.payload.id]: action.payload,
          },
          concatArrayUnique
        ),
        list: union(currentState.list, [action.payload.id]),
      };
    case EThreadsActionType.RESET:
      return {
        ...currentState,
        entries: {},
        list: [],
        meta: {
          currentPage: 0,
          total: 0,
        },
      };
    case EThreadActionType.RESET:
      return merge({}, currentState, {
        entries: {
          [action.payload.threadId]: {
            relationships: {
              messages: {
                list: [],
                meta: {
                  currentPage: 0,
                  total: 0,
                },
              },
            },
          },
        },
      });
    case EMessagesActionType.DELETE:
      return mergeWith(
        {},
        currentState,
        {
          entries: {
            [action.payload.threadId]: {
              relationships: {
                messages: {
                  list: without(
                    currentState.entries[action.payload.threadId].relationships
                      .messages.list,
                    action.payload.messageId
                  ),
                },
              },
            },
          },
        },
        arrayIntersection
      );
    case EThreadActionType.GET_SUCCESS:
    case EMessagesActionType.GET_MORE_SUCCESS:
      return mergeWith(
        {
          entries: {
            [action.payload.threadId]: {
              permissions: {
                [EThreadPermission.CAN_POST_MESSAGE]: true,
              },
            },
          },
        },
        currentState,
        {
          entries: {
            [action.payload.threadId]: {
              relationships: {
                messages: {
                  list: keys(action.payload.entities.messages),
                  meta: action.payload.meta,
                },
              },
            },
          },
        },
        concatArrayUnique
      );
    case EThreadActionType.CHECK_PERMISSION_ERROR:
      const permissions = action.payload.permissions.reduce(
        (acc, permission) => ({ ...acc, [permission]: false }),
        {}
      );

      return mergeWith({}, currentState, {
        entries: {
          [action.payload.threadId]: {
            permissions,
          },
        },
      });
    default:
      return currentState;
  }
};

const arrayIntersection = (objValue: any[], srcValue: any[]) =>
  isArray(objValue) ? intersection(objValue, srcValue) : undefined;

const concatArrayUnique = (objValue: any[], srcValue: any[]) =>
  isArray(objValue) ? union(objValue, srcValue) : undefined;
